export const selectOptionsDocumentStatus = [
  "New Upload",
  "Pending Review",
  "Incomplete",
  "Rejected",
  "Accepted",
];
